import React from 'react'

export default ({
  fields: {
    body
  },
  handleSubmit
}) => (
  <div className='modal-form-block comment-form'>
    <form onSubmit={handleSubmit}>
      <textarea placeholder='Add a comment...' {...body} />

      <div className='modal-form-block submit-button'>
        <button type='submit'>Submit</button>
      </div>
    </form>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/comments/comment-form.js